import MuiButton from './muiButton';

const overrides = ({ palette }) => ({
  MuiButton: MuiButton({ palette }),
});

export default overrides;
